import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import { logError } from '@log';

export const useQuery = (needDecode = true) => {
  const { search = '' } = useLocation();
  let query = {};

  try {
    query = qs.parse(search, {
      decode: needDecode,
    }) || {};
  } catch (error) {
    logError(error);
    return { query };
  }

  return {
    query,
  };
};
